import type { APIResponse } from "../types/common";

import { processError } from "../utils";

export async function authLogin({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<
  APIResponse<{
    access_token: string;
    token_type: string;
    expires_in: number;
    refresh_expires_in: number;
    refresh_token: string;
  }>
> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/auth/login`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          email,
          password,
        }),
      }
    );

    if (response.status !== 200)
      return {
        success: false,
        error:
          response.status === 401 ? "Invalid credentials" : "Invalid input",
      };

    const body = await response.json();
    return {
      success: true,
      data: body,
    };
  } catch (e) {
    return {
      success: false,
      error: processError(e),
    };
  }
}

export async function authRegister({
  username,
  email,
  password,
}: {
  username: string;
  email: string;
  password: string;
}): Promise<APIResponse> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/auth/register`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          username,
          email,
          password,
        }),
      }
    );

    if (response.status !== 201)
      return {
        success: false,
        error:
          response.status === 409
            ? "Email already registered"
            : "Invalid input",
      };

    return {
      success: true,
      data: null,
    };
  } catch (e) {
    return {
      success: false,
      error: processError(e),
    };
  }
}
